import { createFileRoute } from '@tanstack/react-router';

type SearchParams = {
  personPhone?: string;
  personId?: string;
  isNew?: boolean;
  departmentId?: string;
  smsId?: string;
  smsCreatedAt?: string;
  click?: number;
  isArchived?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/messages/$filter/$groupId_/$threadId')({
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    //TODO: validate any of these search params validity
    return search;
  },
});
